module.exports = "/_next/static/images/platform_6-827b52bbc0ea2d89226ed6893ec05ae4.png";